<template>
  <v-data-table :headers="headers" :items="items" :loading="loading" item-key="id" class="mt-4">
    <template v-slot:[`item.demoUser`]="{ item }">{{ demoUserName(item) }}</template>
    <template v-slot:[`item.userType`]="{ item }">{{ demoUserType(item) }}</template>
    <template v-slot:[`item.school`]="{ item }">{{ item.school || '—' }}</template>
    <template v-slot:[`item.grade`]="{ item }">{{ item.grade || '—' }}</template>
    <template v-slot:[`item.country`]="{ item }">{{ item.country || '—' }}</template>
    <template v-slot:[`item.startingDate`]="{ item }">{{ formatCalendarDate(item.startingDate) }}</template>
    <template v-slot:[`item.finishDate`]="{ item }">{{ formatCalendarDate(item.finishDate) }}</template>
    <template v-slot:[`item.lastLoginAt`]="{ item }">{{ item.lastLoginAt ? formatDate(item.lastLoginAt) : '—' }}</template>
    <template v-slot:[`item.link`]="{ item }">
      <v-btn icon small @click="copy(item.activationCode)" :title="$t('demos.copy_link')">
        <v-icon small>mdi-content-copy</v-icon>
      </v-btn>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-btn text small color="red" @click="$emit('revoke', item)">{{ $t('demos.revoke') }}</v-btn>
    </template>
  </v-data-table>
</template>

<script>
import snackbarMixin from '../../mixins/snackbar';

export default {
  name: 'DemosDataTable',
  mixins: [snackbarMixin],
  props: {
    items: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    linkBase: {
      type: String,
      default: process.env.VUE_APP_DEMO_LINK_BASE_URL || 'https://auth.beeverso.org/demo',
    },
  },
  computed: {
    headers() {
      return [
        { text: this.$t('demos.client'), value: 'client' },
        { text: this.$t('demos.reason'), value: 'reason' },
        { text: this.$t('demos.demo_user'), value: 'demoUser' },
        { text: this.$t('demos.account_type'), value: 'userType' },
        { text: this.$t('demos.school'), value: 'school' },
        { text: this.$t('demos.grade'), value: 'grade' },
        { text: this.$t('demos.country'), value: 'country' },
        { text: this.$t('demos.starting_date'), value: 'startingDate' },
        { text: this.$t('demos.finish_date'), value: 'finishDate' },
        { text: this.$t('demos.login_count'), value: 'loginCount' },
        { text: this.$t('demos.last_login'), value: 'lastLoginAt' },
        { text: this.$t('demos.link'), value: 'link', sortable: false },
        { text: '', value: 'actions', sortable: false },
      ];
    },
  },
  methods: {
    formatDate(value) {
      return value ? this.$moment(value).format('DD/MM/YYYY') : '';
    },
    // startingDate/finishDate son columnas DATE (sin hora): MySQL las devuelve
    // como medianoche UTC, así que hay que leerlas en UTC para no correrlas un
    // día para atrás en timezones negativos (ej. UTC-3).
    formatCalendarDate(value) {
      return value ? this.$moment.utc(value).format('DD/MM/YYYY') : '';
    },
    demoUserName(item) {
      const name = [item.firstname, item.lastname].filter(Boolean).join(' ');
      return name || '—';
    },
    demoUserType(item) {
      if (item.userType === 0) return this.$t('demos.type_student');
      if (item.userType === 2) return this.$t('demos.type_teacher');
      return '—';
    },
    copy(activationCode) {
      navigator.clipboard.writeText(`${this.linkBase}?token=${activationCode}`);
      this.snackbarSuccess(this.$t('demos.copied'));
    },
  },
};
</script>
